import React from 'react';
import style from './Lasso.module.scss';
import { sanitizeHTML } from '@benzinga/frontend-utils';

export const BenzingaLassoBlock = ({ block }) => {
  const containerClassname = `${style.bz_las_wrap}`;
  return (
    <div className={containerClassname}>
      <div dangerouslySetInnerHTML={{ __html: sanitizeHTML(block.innerHTML) }} />
    </div>
  );
};
